import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tool } from '../../models/tool';

@Component({
  standalone: true,
  selector: 'app-tool-card',
  imports: [CommonModule],
  templateUrl: './tool-card.html',
  styleUrl: './tool-card.scss',
})
export class ToolCard {
  @Input() tool!: Tool;
  imageError = false;

  openTool(): void {
    const safeUrl = this.toSafeHttpUrl(this.tool?.url);
    if (safeUrl) {
      // noopener,noreferrer prevents the opened page from accessing window.opener.
      window.open(safeUrl, '_blank', 'noopener,noreferrer');
    }
  }

  /**
   * Returns the url only when it is an absolute http(s) URL. Any other scheme
   * (javascript:, data:, vbscript:, file:, ...) is rejected so a maliciously
   * stored tool URL cannot execute script when opened.
   */
  private toSafeHttpUrl(url: string | null | undefined): string | null {
    if (!url) {
      return null;
    }
    try {
      const parsed = new URL(url.trim());
      return parsed.protocol === 'http:' || parsed.protocol === 'https:'
        ? parsed.href
        : null;
    } catch {
      return null;
    }
  }

  onImageError(): void {
    this.imageError = true;
  }
}
